/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, useRef, type DependencyList } from 'react';
import { defaultProps } from '@jira/platform__default-props/src/defaultProps.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Command } from '../../common/types/commands/index.tsx';
import { useSubscribeCommandsWithRegistry } from '../use-subscribe-commands/index.tsx';

/**
 * @deprecated if using in jira. Prefer:
 * import { useRegisterCommands } from '@jira/compal__registry';
 */
export function useRegisterCommandsWithRegistry<T extends string>(
	registrationId: T,
	commands: Command[],
	dependencies: DependencyList = fg('jfp_magma_jira-stable-defaultprops')
		? defaultProps.emptyArray
		: [],
): void {
	const subscribe = useSubscribeCommandsWithRegistry<T>();

	const commandCache = useRef(commands);

	useEffect(() => {
		commandCache.current = commands;
	}, [commands]);

	// oxlint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => subscribe(registrationId, commandCache.current), [...dependencies, subscribe]);
}
